module.exports = __webpack_public_path__ + "static/media/accessControlBuilding.bab95bc2.png";